import { Routes } from '@angular/router';

import { HypeComponent } from '../../../Common/Layout/components/Hype/hype.component';
import { EntityFullProfileComponent } from '../../../Common/RhpContexts/components/Entity/entity-full-profile.component';
import { FullProfileDialogComponent } from '../../../Common/RhpContexts/components/Entity/FullProfileDialog/full-profile-dialog.component';

export const profileRoutes: Routes = [
    {
        path: '',
        component: HypeComponent
    },
    {
        path: 'contact',
        component: EntityFullProfileComponent
    },
    {
        path: 'contact/:contactId',
        component: FullProfileDialogComponent
    },
    {
        path: 'outlet/:outletId',
        component: FullProfileDialogComponent
    },
    {
        path: '**',
        redirectTo: '/Discover/targetingsearches'
    }
];
